import { SearchTask } from 'bloggers-backend/lib/youtube/domain/SearchTask';

export function hasSearchTaskChanged(previous: SearchTask, next: SearchTask): boolean {
  return JSON.stringify(previous) !== JSON.stringify(next);
}
